module.exports = __webpack_public_path__ + "6949cca9a390573d5a1ebdad3cf246f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/franchise-png.png
// module id = 77
// module chunks = 0